import { render, staticRenderFns } from "./ListSitenotifications.vue?vue&type=template&id=d0c9fb1a&"
import script from "./ListSitenotifications.vue?vue&type=script&lang=js&"
export * from "./ListSitenotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports